import type { ISODate } from "@mctypes/frontend.types";
import { z } from "zod";

const isValidISODateFrontend = (x: string) => {
  try {
    return new Date(x).toISOString() === x;
  } catch (err) {
    return false;
  }
};

export const isoDate = z
  .string()
  .length(24)
  .refine(isValidISODateFrontend, (x) => ({ message: `${x} is not a valid ISO date` }))
  .brand<"ISODate">();

export const isoToDate = isoDate.transform((x) => new Date(x));

export const toISODate = (date: Date) => date.toISOString() as ISODate;
export const toDate = (date: ISODate) => new Date(date);
